import { CommonModule } from '@angular/common';
import { Component, Input, Renderer2, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FadeInOut } from 'src/app/animations/animations';

export enum PopupPosition {
  Above = 'above',
  Below = 'below',
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  animations: [FadeInOut],
})
export class CopyButtonComponent implements OnInit {
  @Input() public value: string;
  @Input() public text?: string = undefined;
  @Input() public isSecondaryFontColor = false;
  @Input() public withCopyIcon = true;
  @Input() public fixedSize = true;
  @Input() public successPopupPosition = PopupPosition.Right;

  public showCopyPopUp = false;
  public popupStyle: { [key: string]: string } = {};

  constructor(private readonly _renderer: Renderer2) {}

  ngOnInit(): void {
    this.popupStyle = this._getPopupPositionStyle(this.successPopupPosition);
  }

  public copyValue() {
    navigator.clipboard.writeText(this.value);
    this.showCopyPopUp = true;
  }

  private _getPopupPositionStyle(position: PopupPosition): {
    [key: string]: string;
  } {
    const POPUP_GAP_PRESENTERS = '130%';
    switch (position) {
      case PopupPosition.Above:
        return { bottom: POPUP_GAP_PRESENTERS };
      case PopupPosition.Below:
        return { top: POPUP_GAP_PRESENTERS };
      case PopupPosition.Left:
        return { right: POPUP_GAP_PRESENTERS };
      case PopupPosition.Right:
        return { left: POPUP_GAP_PRESENTERS };
      case PopupPosition.Center:
        return {};
      default:
        console.error(`${position} position do not have a position implementation on cope button tooltip.`);
        return { left: POPUP_GAP_PRESENTERS };
    }
  }
}
